import { createSlice } from "@reduxjs/toolkit";
import { update_shortcuts_thunk, get_shortcut_thunk } from "./shortcutThunk";
import { DEFAULT_SHORTCUTS, isMacOS, WINDOWS_DEFAULT_SHORTCUTS } from "../../common/common";

const initialState = {
    loading: false,
    shortcuts: (() => {
        try {
            const storedShortcuts = localStorage.getItem('shortCuts');
            const defaultOsShortcuts = isMacOS()
                ? DEFAULT_SHORTCUTS
                : WINDOWS_DEFAULT_SHORTCUTS;

            if (!storedShortcuts) {
                return defaultOsShortcuts;
            }

            const parsedShortcuts = JSON.parse(storedShortcuts);
            if (Object.keys(parsedShortcuts).length > 0) {
                return parsedShortcuts;
            }
            return defaultOsShortcuts;

        } catch (error) {
            console.error("Error parsing shortCuts from localStorage:", error);
            return isMacOS() ? DEFAULT_SHORTCUTS : WINDOWS_DEFAULT_SHORTCUTS;
        }
    })(),
    error: null,
};


const loadShortCutsFromLocalStorage = () => {
    const shortcuts = localStorage.getItem('shortCuts');
    // Check if openTabs is null or an empty string
    if (!shortcuts || shortcuts === 'undefined') {
        return {};
    }
    try {
        return JSON.parse(shortcuts);
    } catch (error) {
        console.error('Error parsing JSON:', error);
        return {};
    }
};

const updateShortcutCases = (builder) => {
    builder
        .addCase(update_shortcuts_thunk.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(update_shortcuts_thunk.fulfilled, (state, action) => {
            state.loading = false;
        })
        .addCase(update_shortcuts_thunk.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Login Cases Error";
        });
};

const getShortcutCases = (builder) => {
    builder
        .addCase(get_shortcut_thunk.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(get_shortcut_thunk.fulfilled, (state, action) => {
               let osShortcuts = isMacOS()
                    ? action.payload.data.shortcuts
                    : action.payload.data.windowsShortcuts;
            let shortcuts = osShortcuts;
            if(Object.keys(shortcuts).length === 0) {
                  let defaultOsShortcuts = isMacOS()
                        ? DEFAULT_SHORTCUTS
                        : WINDOWS_DEFAULT_SHORTCUTS;
                state.shortcuts = defaultOsShortcuts;
            }
            else{
                state.shortcuts = osShortcuts;
            }
            state.loading = false;
        })
        .addCase(get_shortcut_thunk.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Login Cases Error";
        });
};

const shortcutSlice = createSlice({
    name: "shortcut",
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        getShortcutsFromLocalStorage: (state, action) => {
            state.shortcuts = loadShortCutsFromLocalStorage();
        },
        setShortCuts: (state, action) => {
            state.shortcuts = action.payload;
            localStorage.setItem('shortCuts', JSON.stringify(action.payload));
        },
        clearShortcuts: (state) => {
            state.shortcuts = {};
        },

    },
    extraReducers: (builder) => {
        updateShortcutCases(builder);
        getShortcutCases(builder);
        // logoutCases(builder);
    },
});

export const { clearError, getShortcutsFromLocalStorage, setShortCuts, clearShortcuts } = shortcutSlice.actions;

export default shortcutSlice.reducer;
